import axios from 'axios'
import {
  PROGRAM_CREATE_FAIL,
  PROGRAM_CREATE_REQUEST,
  PROGRAM_CREATE_SUCCESS,
  PROGRAM_DELETE_FAIL,
  PROGRAM_DELETE_REQUEST,
  PROGRAM_DELETE_SUCCESS,
  PROGRAM_LIST_FAIL,
  PROGRAM_LIST_REQUEST,
  PROGRAM_LIST_SUCCESS,
  PROGRAM_UPDATE_FAIL,
  PROGRAM_UPDATE_REQUEST,
  PROGRAM_UPDATE_SUCCESS,
} from '../constants/programConstants'

export const createProgram = (program) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PROGRAM_CREATE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(`/api/programs`, program, config)

    dispatch({
      type: PROGRAM_CREATE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: PROGRAM_CREATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const listUserPrograms = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PROGRAM_LIST_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`/api/programs/list/${id}`, config)

    dispatch({
      type: PROGRAM_LIST_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: PROGRAM_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const deleteProgram = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PROGRAM_DELETE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    await axios.delete(`/api/programs/${id}`, config)

    dispatch({ type: PROGRAM_DELETE_SUCCESS })
  } catch (error) {
    dispatch({
      type: PROGRAM_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const updateProgram = (program) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PROGRAM_UPDATE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(
      `/api/programs/${program._id}`,
      program,
      config
    )

    dispatch({
      type: PROGRAM_UPDATE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: PROGRAM_UPDATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}
